import { isNil } from 'ramda';

export interface VatItem {
  trueVatAmount: number | null;
  trueVatRate: number | null;
  vatAmountItemId?: string;
}

const isVatItemValid = (item: VatItem) =>
  !isNil(item.trueVatRate) && !isNil(item.trueVatAmount);

export const formatInput = (values: VatItem[]) =>
  values.filter(isVatItemValid).map((item) => ({
    ...item,
    // safe because null values are filtered beforehand
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    trueVatAmount: Number(item.trueVatAmount!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    trueVatRate: Number(item.trueVatRate! / 100),
  }));
